import { jsx as _jsx } from "react/jsx-runtime";
import { generateUuid } from '@zurich-framework/core/utils';
import { createContext, useContext } from 'react';
export const BusinessProcessIdContext = createContext(generateUuid());
export function useBusinessProcessId() {
    return useContext(BusinessProcessIdContext);
}
export function BusinessProcessIdProvider({ businessProcessId, children, }) {
    return (_jsx(BusinessProcessIdContext.Provider, { value: businessProcessId, children: children }));
}
